import { useEffect, useState } from 'react'

export const useRemainingTime = ({
  startedAtMs,
  estimatedTimeMs,
}: {
  startedAtMs?: number
  estimatedTimeMs?: number
} = {}) => {
  const [progress, setProgress] = useState(100)
  const [remainingTimeMs, setRemainingTimeMs] = useState(0)

  useEffect(() => {
    if (!startedAtMs || !estimatedTimeMs) return

    const updateProgress = () => {
      const now = Date.now()
      const elapsed = now - startedAtMs
      const percentage = Math.max(
        (1 - elapsed / (estimatedTimeMs - startedAtMs)) * 100,
        0,
      )
      setProgress(percentage)
      setRemainingTimeMs(estimatedTimeMs - now)
    }

    updateProgress()

    const intervalId = setInterval(
      () => {
        updateProgress()
      },
      1000, // Update every s
    )

    return () => clearInterval(intervalId)
  }, [estimatedTimeMs, startedAtMs])

  return { progress, remainingTimeMs }
}
